import formatError from "@/utils/formatError";
import { captureException } from "@sentry/react";

/**
 *
 * @param error This can be a core-api or an axios error
 * @param queryFn the name of the request
 * @returns
 */
const logError = (error: IApiError | Error | null, context?: string) => {
  const formattedError = formatError(error);

  if (!import.meta.env.PROD) {
    console.error(`Error on : ${context} \n`);

    if (formattedError?.errors) {
      console.error(formattedError?.errors);
    } else if (formattedError) {
      console.error(formattedError?.message);
    } else {
      console.error(error);
    }
  }

  if (formattedError) {
    const { message } = formattedError;

    captureException(message, {
      extra: { context: context },
    });
  } else {
    captureException(error, { extra: { context: context } });
  }
};

export default logError;
